import { FaFacebookF, FaGooglePlusG, FaYoutube } from "react-icons/fa";
import "./Footer.scss";
import { Link } from "react-router-dom";
import { IoLogoWhatsapp } from "react-icons/io";

const date = new Date();

let d = new Intl.DateTimeFormat("en-GB", {
  year: "numeric",
}).format(date);

const Footer = () => {
  return (
    <div className="footer">
      <div className="footerBottom">
        <div className="footerBottomWrapper">
          <div className="left">
            <p>
              &copy; {d} <Link to="/">Becky</Link>news. All Right Reserved
            </p>
          </div>
          <div className="right">
            <ul className="nav1">
              <li>
                <Link>Home</Link>
              </li>
              <li>
                <Link>FAQ</Link>
              </li>
              <li>
                <Link>Support</Link>
              </li>
            </ul>

            <ul className="nav2">
              <li>
                <Link>
                  <FaFacebookF size={18} />
                </Link>
              </li>
              <li>
                <Link>
                  <IoLogoWhatsapp size={18} />
                </Link>
              </li>
              <li>
                <Link>
                  <FaGooglePlusG size={18} />
                </Link>
              </li>
              <li>
                <Link>
                  <FaYoutube size={18} />
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
